export const publicRoutes = [
	"/", // home
	"/login", // signin
	"/cadastro", // signup
	"/negociacao-simplificada", // signUpNCAD
	"/cadastro-ncad-completo", // signupNCADCompleted
	"/cadastro/erro-informacoes", // signupACPErrorKBA
	"/cadastro/falha-ao-validar-informacoes", // signupACPBlockedKBA
	"/recuperar-senha/erro-informacoes", // recoveryPasswordACPInvalidKBA
	"/recuperar-senha/falha-ao-validar-informacoes", // recoveryPasswordACPBlockedKBA
	"/redefinir-senha/erro-informacoes", // resetPasswordACPInvalidKBA
	"/redefinir-senha/falha-ao-validar-informacoes", // resetPasswordACPBlockedKBA
	"/falha-ao-validar-documento", // signinACPFailedDocument
	"/recuperar-senha", // recoveryPassword
	"/redefinir-senha", // redefinePassword
	"/criar-senha", // redefinePasswordCP
	"/conta-cancelada", // accountCanceled
	"/cadastro/erro-faltando-informacoes", // errorNoData
	"/cadastro/erro-kba-limite", // errorKba
	"/cadastro/erro-kba-invalido", // errorKbaBigDataCorp
];
